import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ca from './ca.json';
import es from './es.json';
import en from './en.json';
import StorageAbstractFactory from '@infrastructure/cache';

export const resources = {
  ca: {
    translation: ca,
  },
  es: {
    translation: es,
  },
  en: {
    translation: en,
  },
};

const defaultLang = process.env.NODE_ENV === 'test' ? 'en' : StorageAbstractFactory.getSyncGlobalInstance().getItem('i18nextLng') ?? 'ca';

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLang,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
